/*Initialize global tooltips*/
$(function () {

    $('[data-toggle="popover"]').popover({
        offset: '0 40',
        trigger: 'hover'
    });

    $(".tooltip-btn").click(function(event) {
        event.preventDefault();
    });

});